module.exports = __webpack_public_path__ + "b200a48581a601c71c2164d030aa74bd.png";